/*============================================================================
  Custom infinite scroll functionality for collection product grids.

  - Replaces numbered pagination with auto-loading on scroll.
  - Toggleable per-collection via the "Enable infinite scroll" setting on the
    Product grid block (data-infinite-scroll attribute).
  - Re-binds after AJAX filtering/sorting (listens for 'collection:reloaded').
  - Fetches the next page through the Section Rendering API (section_id) so the
    current filters and sort order are always preserved in the next-page URL.
==============================================================================*/
(function () {
  var selectors = {
    section: '[data-section-type="collection-grid"]',
    productGrid: '[data-product-grid]',
    gridItems: '.grid--uniform',
    pagination: '.pagination',
    nextLink: '.next a'
  };

  function InfiniteScroll(container) {
    this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.observer = null;
    this.sentinel = null;
    this.spinner = null;
    this.nextUrl = null;
    this.loading = false;

    this.setup = this.setup.bind(this);
    this.onIntersect = this.onIntersect.bind(this);

    this.setup();
    document.addEventListener('collection:reloaded', this.setup);
  }

  InfiniteScroll.prototype.setup = function () {
    this.teardown();

    this.productGrid = this.container.querySelector(selectors.productGrid);
    this.itemsContainer = this.container.querySelector(selectors.gridItems);
    this.pagination = this.container.querySelector(selectors.pagination);

    if (!this.productGrid || !this.itemsContainer) {
      return;
    }

    var enabled = this.productGrid.getAttribute('data-infinite-scroll') === 'true';

    if (!enabled) {
      if (this.pagination) {
        this.pagination.style.display = '';
      }
      return;
    }

    var nextLink = this.pagination
      ? this.pagination.querySelector(selectors.nextLink)
      : null;
    this.nextUrl = nextLink ? nextLink.getAttribute('href') : null;

    if (this.pagination) {
      this.pagination.style.display = 'none';
    }

    if (!this.nextUrl) {
      return;
    }

    this.createSentinel();
    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: '800px 0px'
    });
    this.observer.observe(this.sentinel);
  };

  InfiniteScroll.prototype.createSentinel = function () {
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'infinite-scroll__sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');

    this.spinner = document.createElement('div');
    this.spinner.className = 'infinite-scroll__spinner';
    this.sentinel.appendChild(this.spinner);

    this.productGrid.appendChild(this.sentinel);
  };

  InfiniteScroll.prototype.onIntersect = function (entries) {
    var self = this;
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        self.loadNext();
      }
    });
  };

  InfiniteScroll.prototype.loadNext = function () {
    if (this.loading || !this.nextUrl) {
      return;
    }

    this.loading = true;
    if (this.sentinel) {
      this.sentinel.classList.add('is-loading');
    }

    var separator = this.nextUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = this.nextUrl + separator + 'section_id=' + this.sectionId;

    var self = this;
    fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        self.appendProducts(html);
      })
      .catch(function () {
        self.finish();
      });
  };

  InfiniteScroll.prototype.appendProducts = function (html) {
    var newDom = new DOMParser().parseFromString(html, 'text/html');
    var newItemsContainer = newDom.querySelector(selectors.gridItems);

    if (newItemsContainer && this.itemsContainer) {
      var fragment = document.createDocumentFragment();
      Array.prototype.slice.call(newItemsContainer.children).forEach(function (child) {
        fragment.appendChild(child);
      });
      this.itemsContainer.appendChild(fragment);
    }

    var newPagination = newDom.querySelector(selectors.pagination);
    var newNextLink = newPagination
      ? newPagination.querySelector(selectors.nextLink)
      : null;
    this.nextUrl = newNextLink ? newNextLink.getAttribute('href') : null;

    if (window.theme && typeof theme.reinitProductGridItem === 'function') {
      theme.reinitProductGridItem(this.container);
    }

    if (window.lazySizes && lazySizes.loader && lazySizes.loader.checkElems) {
      lazySizes.loader.checkElems();
    }

    document.dispatchEvent(new CustomEvent('collection:itemsAppended'));

    this.loading = false;
    if (this.sentinel) {
      this.sentinel.classList.remove('is-loading');
    }

    if (!this.nextUrl) {
      this.finish();
    }
  };

  InfiniteScroll.prototype.finish = function () {
    this.loading = false;
    if (this.observer && this.sentinel) {
      this.observer.unobserve(this.sentinel);
    }
    if (this.sentinel && this.sentinel.parentNode) {
      this.sentinel.parentNode.removeChild(this.sentinel);
    }
    this.sentinel = null;
  };

  InfiniteScroll.prototype.teardown = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.sentinel && this.sentinel.parentNode) {
      this.sentinel.parentNode.removeChild(this.sentinel);
    }
    this.sentinel = null;
    this.loading = false;
  };

  function init() {
    if (!('IntersectionObserver' in window)) {
      return;
    }
    document.querySelectorAll(selectors.section).forEach(function (container) {
      if (!container.infiniteScrollInstance) {
        container.infiniteScrollInstance = new InfiniteScroll(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
